import { render, staticRenderFns } from "./LogoutDialog.vue?vue&type=template&id=796e1480&scoped=true&"
import script from "./LogoutDialog.vue?vue&type=script&lang=js&"
export * from "./LogoutDialog.vue?vue&type=script&lang=js&"
import style0 from "./LogoutDialog.vue?vue&type=style&index=0&id=796e1480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e1480",
  null
  
)

export default component.exports